export default __webpack_public_path__ + "static/1083-cdfee1bf9ea84ea4eff04090cdfc5a91.gif";